module.exports = __webpack_public_path__ + "img/logo-round.1d242b85.png";